import {
  HISTORY_LENGTH,
  type Settings,
  zoneOf,
} from "@/lib/tool-kit/games-organizers/noise-meter";

const WIDTH = 240;
const HEIGHT = 60;
const STEP = WIDTH / HISTORY_LENGTH;

const FILL = {
  quiet: "fill-emerald-500",
  talk: "fill-amber-500",
  loud: "fill-red-500",
} as const;

/** The last minute of levels, newest on the right, one bar every half second. */
export default function NoiseHistory({
  history,
  settings,
  label,
}: {
  history: readonly number[];
  settings: Settings;
  label: string;
}) {
  const offset = HISTORY_LENGTH - history.length;
  return (
    <svg
      aria-label={label}
      className="block h-20 w-full rounded-lg border border-border bg-muted"
      preserveAspectRatio="none"
      role="img"
      viewBox={`0 0 ${WIDTH} ${HEIGHT}`}
    >
      {history.map((level, i) => {
        const height = Math.max(1, Math.round((level / 100) * HEIGHT));
        const zone = zoneOf(level, settings.quietBelow, settings.loudAbove);
        return (
          <rect
            className={FILL[zone]}
            height={height}
            // biome-ignore lint/suspicious/noArrayIndexKey: bars are positional samples
            key={i}
            width={Math.round(STEP * 10) / 10}
            x={Math.round((offset + i) * STEP * 10) / 10}
            y={HEIGHT - height}
          />
        );
      })}
    </svg>
  );
}
